import useGetQuery from '_api/queries/useGetQuery';
import { AccountType, ConstantsNameDescriptions } from '_api/types';

export const GET_ACCOUNT_TYPES = 'get-account-types';

export const useGetAccountType = () =>
  useGetQuery<ConstantsNameDescriptions<AccountType>[]>(
    () => '/user/accountTypes',
    {},
    [GET_ACCOUNT_TYPES],
    {
      refetchOnWindowFocus: false,
    },
  );
